import api from "../../index";

export const GetAllDepositRequestApi = (params) => api.get(`WalletMaster/Get-All-Deposit-Request?${params}`);
export const AcceptRejectDepositRequestApi = (data) => api.post('WalletMaster/Approved-Reject-Deposit-Request', data);